import swal from "sweetalert2";

export async function confirmUnsavedChanges() {
	try {
		const result = await swal.fire({
			title: "Confirm Action",
			html: "<p>You have unsaved changes, are you sure you want to close this dialog?</p>",

			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Confirm"
		});
		
		return !!result.value;
	}catch(error) {		
		return false;
	}
}